export const getSeoLevelCol1 = (rowIndex: number, childIndex: number) => {
  let seoLevel = 1;
  if (rowIndex > 0) {
    seoLevel++;
  }
  if (childIndex > 0) {
    seoLevel++;
  }
  return seoLevel;
};

export const getSeoLevelCol2 = (
  rowIndex: number,
  _childIndex: number,
  component: { designVariant?: string },
) => {
  let seoLevel = 2;
  if (component?.designVariant === 'solo') {
    seoLevel++;
  }
  return seoLevel;
};

export const getHeaderDisplayLevel = (seoLevel: number) => {
  const seoDisplayLevel = seoLevel === 1 ? 1 : 2;
  return seoDisplayLevel;
};
